import { render } from "./pricingcard.vue?vue&type=template&id=a45b7884&scoped=true"
import script from "./pricingcard.vue?vue&type=script&lang=js"
export * from "./pricingcard.vue?vue&type=script&lang=js"

import "./pricingcard.vue?vue&type=style&index=0&id=a45b7884&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45b7884"]])

export default __exports__